import { URL_LIST_JOBS, URL_ACCOUNT_SELECT } from '@seek/adv-constants';

import { navigateToPage } from './../../../utils/window';
import { getSignInUrl } from './getSignInUrl';

export const navigateToJobListPage = () => {
  navigateToPage(URL_LIST_JOBS);
};

export const navigateToSignInPageWithReturnUrl = () => {
  navigateToPage(getSignInUrl());
};

export const navigateToAccountSelectionPage = () => {
  navigateToPage(URL_ACCOUNT_SELECT);
};
